export default {
  center: () => import("/vercel/path0/layouts/center.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  partners: () => import("/vercel/path0/layouts/partners.vue").then(m => m.default || m),
  terms: () => import("/vercel/path0/layouts/terms.vue").then(m => m.default || m),
  voucher: () => import("/vercel/path0/layouts/voucher.vue").then(m => m.default || m)
}